import React from 'react';
import style from './style.module.scss';

interface AnalyticsActionBarProps {
    children: React.ReactNode;
    stacked?: boolean;
}

export const AnalyticsActionBar: React.FC<AnalyticsActionBarProps> = ({
    children,
    stacked = false,
}) => {
    return (
        <div className={`${style.action_bar} ${stacked ? style.stacked : ''}`}>
            {children}
        </div>
    );
};
